<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M48 8c1.368 0 2.495 1.03 2.649 2.356l.018.31V32l-.001.027v21.306C50.667 54.806 49.474 56 48 56c-1.368 0-2.495-1.03-2.649-2.356l-.018-.31V34.665H19.772l6.114 6.115c.96.961 1.035 2.474.221 3.52l-.221.251c-.962.962-2.474 1.036-3.52.222l-.252-.222-10.666-10.666c-.962-.962-1.036-2.474-.222-3.52l.222-.252 10.666-10.666c1.042-1.042 2.73-1.042 3.772 0 .96.961 1.035 2.474.221 3.52l-.221.251-6.113 6.114h25.56V10.667C45.333 9.194 46.527 8 48 8z" transform="translate(-210 -1215) translate(210 1215)"/>
            </g>
        </g>
    </g>
</svg>
